import React, { PureComponent } from "react";
import { Link } from "react-router-dom";
import ResponsiveMenu from "react-responsive-navbar";

import ROUTE_CONSTANTS from "../routes/ROUTE_CONSTANTS";

import "./navigation.css";

class Navigation extends PureComponent {
  render() {
    return (
      <ResponsiveMenu
        menuOpenButton={menuIcon}
        menuCloseButton={cancelIcon}
        changeMenuOn="500px"
        largeMenuClassName="large-menu-classname"
        smallMenuClassName="small-menu-classname"
        menu={menu}
      />
    );
  }
}

export default Navigation;

const styleMenuItem = {
  margin: 10
};

const menu = (
  <div
    style={{
      display: "flex",
      flexWrap: "wrap",
      textAlign: "center"
    }}
  >
    <div style={styleMenuItem}>
      <Link to={ROUTE_CONSTANTS.HOME}>Home</Link>
    </div>

    <div style={styleMenuItem}>
      <Link to={ROUTE_CONSTANTS.VIDEOS}>Videos</Link>
    </div>

    <div style={styleMenuItem}>
      <Link to={ROUTE_CONSTANTS.MUSIC}>Music</Link>
    </div>

    <div style={styleMenuItem}>
      <Link to={ROUTE_CONSTANTS.PICS}>Pics</Link>
    </div>

    <div style={styleMenuItem}>
      <Link to={ROUTE_CONSTANTS.CALENDAR}>Calendar</Link>
    </div>

    <div style={styleMenuItem}>
      <Link to={ROUTE_CONSTANTS.ABOUT}>About</Link>
    </div>

    <div style={styleMenuItem}>
      <Link to={ROUTE_CONSTANTS.CONTACT}>Contact</Link>
    </div>
  </div>
);

const menuIcon = (
  <svg
    version="1.1"
    viewBox="0 0 24 24"
    // enable-background="new 0 0 24 24"
    height="32"
  >
    <g>
      <path d="M24,3c0-0.6-0.4-1-1-1H1C0.4,2,0,2.4,0,3v2c0,0.6,0.4,1,1,1h22c0.6,0,1-0.4,1-1V3z" />
      <path d="M24,11c0-0.6-0.4-1-1-1H1c-0.6,0-1,0.4-1,1v2c0,0.6,0.4,1,1,1h22c0.6,0,1-0.4,1-1V11z" />
      <path d="M24,19c0-0.6-0.4-1-1-1H1c-0.6,0-1,0.4-1,1v2c0,0.6,0.4,1,1,1h22c0.6,0,1-0.4,1-1V19z" />
    </g>
  </svg>
);

const cancelIcon = (
  <svg
    version="1.1"
    viewBox="0 0 21.9 21.9"
    // enable-background="new 0 0 21.9 21.9"
    height="32"
  >
    <path d="M14.1,11.3c-0.2-0.2-0.2-0.5,0-0.7l7.5-7.5c0.2-0.2,0.3-0.5,0.3-0.7s-0.1-0.5-0.3-0.7l-1.4-1.4C20,0.1,19.7,0,19.5,0  c-0.3,0-0.5,0.1-0.7,0.3l-7.5,7.5c-0.2,0.2-0.5,0.2-0.7,0L3.1,0.3C2.9,0.1,2.6,0,2.4,0S1.9,0.1,1.7,0.3L0.3,1.7C0.1,1.9,0,2.2,0,2.4  s0.1,0.5,0.3,0.7l7.5,7.5c0.2,0.2,0.2,0.5,0,0.7l-7.5,7.5C0.1,19,0,19.3,0,19.5s0.1,0.5,0.3,0.7l1.4,1.4c0.2,0.2,0.5,0.3,0.7,0.3  s0.5-0.1,0.7-0.3l7.5-7.5c0.2-0.2,0.5-0.2,0.7,0l7.5,7.5c0.2,0.2,0.5,0.3,0.7,0.3s0.5-0.1,0.7-0.3l1.4-1.4c0.2-0.2,0.3-0.5,0.3-0.7  s-0.1-0.5-0.3-0.7L14.1,11.3z" />
  </svg>
);



// WEBPACK FOOTER //
// ./src/Navigation/Navigation.js